import React, { Fragment } from "react";
import { Disclosure, Transition } from "@headlessui/react";
import { ChevronDown } from "lucide-react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function FAQ({ eyebrow, title, subtitle, items = [] }) {
  if (!items.length) return null;

  return (
    <section className="eb-section bg-white">
      <div className="eb-container">
        <div className="max-w-2xl">
          {eyebrow ? <div className="eb-pill">{eyebrow}</div> : null}
          <h2 className="mt-4 eb-h2">{title}</h2>
          {subtitle ? <p className="mt-4 text-lg eb-muted">{subtitle}</p> : null}
        </div>

        <div className="mt-10 divide-y divide-slate-200 rounded-2xl border border-slate-200 bg-white">
          {items.map((item) => (
            <Disclosure key={item.q} as="div" className="p-4 sm:p-6">
              {({ open }) => (
                <>
                  <Disclosure.Button className="flex w-full items-start justify-between gap-4 text-left">
                    <span className="text-sm sm:text-base font-semibold text-slate-900">{item.q}</span>
                    <ChevronDown
                      className={classNames("h-5 w-5 text-slate-600 transition-transform", open && "rotate-180")}
                      aria-hidden="true"
                    />
                  </Disclosure.Button>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 -translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 -translate-y-1"
                  >
                    <Disclosure.Panel className="mt-3 text-sm text-slate-600 leading-6">
                      {item.a}
                    </Disclosure.Panel>
                  </Transition>
                </>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
    </section>
  );
}

